'use strict';

exports.__esModule = true;
var POSITIONS = exports.POSITIONS = ['left', 'top', 'right', 'bottom'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-dock-monitor/lib/constants.js
 ** module id = 249
 ** module chunks = 0
 **/